/**
 * The export class CallResponse class
 */
import { EntityBase } from '@/bases';
import { Appointment } from './Appointment';

export class CallResponse extends EntityBase {
    public CallResult: number | null = null;   
    public VTID: number | null = null;
    public InfoText: string | null = null;
    
    public Appointments : Array<Appointment>;

    constructor(data: any = null) {
      super();
      this.Assign(data);
  }

  public toJSON(): any {
    return {};
  }
}